const map = {
	"./ic_IQsample_correlation-selected.png": 89531,
	"./ic_IQsample_correlation.png": 92233,
	"./ic_IQsample_survey-selected.png": 26833,
	"./ic_IQsample_survey.png": 9795
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90336;